import * as Yup from 'yup';

export const DeliverDateSchema = Yup.object().shape({
  deliveryDate: Yup.date().required('Please provide delivery date'),
});

export type DeliverDateDataType = Yup.InferType<typeof DeliverDateSchema>;

type InitialValues = {
  deliveryDate: string;
};

export const deliverDateInitialValues: InitialValues = {
  deliveryDate: '',
};
